/* eslint-disable quotes */
<template>
	<Transition name="nav-slide">
		<div v-if="show" class="challenge-wrapper d-flex justify-content-center align-items-center">
			<div class="challenge-content d-flex flex-row">
				<div class="d-flex flex-row align-items-center challenge-ends">
					<InlineSvg src="/images/icons/ic-clock.svg" />
					CHALLENGE ENDS
				</div>
				<div class="d-flex flex-row align-items-center">
					<AppCountdown class="countdown" :countdownTime="endDate" />
				</div>
				<div class="d-flex flex-row align-items-center button cursor-pointer" @click="goToChallengeCommunity">
					Go to community
					<InlineSvg src="/images/icons/ic-chevron-right.svg" />
				</div>
			</div>
		</div>
	</Transition>
</template>
<script>
	import axios from 'axios'
	import { mapGetters, mapActions } from 'vuex'
	import OnboardingMixin from '~/pages/dashboard/OnboardingMixin.js'

	export default {
		middleware: 'auth',
		mixins: [OnboardingMixin],
		data() {
			return {
				communityMagicLink: false,
				endDate: undefined,
			}
		},
		computed: {
			...mapGetters('Auth', ['user']),
			show() {
				// Do not show over SB Challenge landing page, and only show on dashboard
				const onDashboard = this.$route.name === 'dashboard'
				return !this.showReferralPreOnboardingDashboard && onDashboard && this.communityMagicLink && this.endDate
			},
		},
		async created() {
			// Banner will only load in if creator is part of challenge and has access to data
			await this.getCommunityAccess()
			await this.getChallengeEndDate()
		},
		methods: {
			...mapActions('Auth', ['fetchUser', 'cancelFetchUser']),
			async getChallengeEndDate() {
				try {
					const response = await axios.get('v1/users/referral_triggered/data')
					if (response.data?.end_date) {
						this.endDate = response.data.end_date
					}
				} catch (error) {
					console.error('Error occurred while calling the API:', error)
				}
			},
			async getCommunityAccess() {
				try {
					const response = await axios.post('v1/users/referral_triggered/join_community')
					if (response.data?.magic_link) {
						this.communityMagicLink = response.data?.magic_link
					}
				} catch (error) {
					console.error('Error occurred while calling the API:', error)
				}
			},
			async goToChallengeCommunity() {
				window.open(this.communityMagicLink, '_self')
			},
			updateNavbarOffset(amount) {
				// If the banner is being shown, update the offset to account for this banners height
				const currentValue = getComputedStyle(document.documentElement)
					.getPropertyValue('--navbar-dynamic-offset')
					.trim()
				const currentPx = parseFloat(currentValue)
				document.documentElement.style.setProperty('--navbar-dynamic-offset', `${currentPx + amount}px`)
			},
		},
		watch: {
			show(newShow, oldShow) {
				const isNotUndefined = newShow !== undefined
				if (isNotUndefined && newShow !== oldShow) {
					this.updateNavbarOffset(newShow ? 50 : -50)
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	.challenge-wrapper {
		background: #000;
		color: #fff;
		min-height: 42px;
		min-height: 42px;

		.challenge-content {
			gap: 13px;
			font-size: 10px;

			.challenge-ends {
				line-height: 1;
				color: #fff;
				font-family: 'Plus Jakarta Sans';
				font-style: normal;
				font-weight: 800;
				letter-spacing: 0.13px;
				gap: 4px;
			}

			.countdown {
				line-height: 1;
				min-width: 120px;
				font-size: 14px;
			}

			.button {
				line-height: 1;
				gap: 4px;
				font-size: 12px;
			}

			svg {
				width: 18px;
				height: 18px;
				&::v-deep {
					path:not(.no-fill),
					rect:not(.no-fill) {
						fill: #fff;
					}
				}
			}
		}

		@media (min-width: 992px) {
			min-height: 50px;
			max-height: 50px;

			.challenge-content {
				gap: 16px;

				.challenge-ends {
					font-size: 13px;
				}

				.countdown {
					min-width: 150px;
					font-size: 16px;
				}

				.button {
					font-size: 14px;
				}
			}
		}
	}

	.nav-slide-enter-active,
	.nav-slide-leave-active {
		transition: transform 0.3s ease, opacity 0.3s ease;
	}

	.nav-slide-enter,
	.nav-slide-leave-to {
		transform: translateY(-100%);
		background-color: white;
	}
</style>
